import React from 'react';
import { PropTypes } from 'prop-types';

class SelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev) {
    const {
      target: { value }
    } = ev;

    let emittedValue = value;

    if (value === '') {
      emittedValue = undefined;
    }

    if (this.props.multiple) {
      emittedValue = this.values();
    }
    if (this.props.onSelect) {
      this.props.onSelect(ev, emittedValue);
    }
  }

  values() {
    if (!this.props.multiple) {
      return [];
    }

    const selectedStateOptions = this.refs.selectBox.selectedOptions;

    const states = [];

    for (let i = 0; i < selectedStateOptions.length; i++) {
      states.push(selectedStateOptions.item(i).value);
    }

    return states;
  }

  setValue(value) {
    this.refs.selectBox.value = value;
    if (this.props.onSelect) {
      this.props.onSelect({ target: { selectedOptions: value } }, value);
    }
  }

  render() {
    const { id, name, style, valueList, defaultValue, multiple, defaultString } = this.props;
    const { handleChange } = this;
    return (
      <select
        id={id}
        name={name}
        style={style}
        onChange={handleChange}
        value={defaultValue}
        multiple={multiple || false}
        ref="selectBox"
      >
        <option value=""> {defaultString} </option>
        {valueList.map(value => (
          <option key={value[1]} value={value[1]}>
            {value[0]}
          </option>
        ))}
      </select>
    );
  }
}

SelectBox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  valueList: PropTypes.array,
  defaultValue: PropTypes.string,
  onSelect: PropTypes.func,
  multiple: PropTypes.bool,
  defaultString: PropTypes.string,
  style: PropTypes.object
};

export default SelectBox;
